import { AssetPreviewImageController } from './asset-preview-image.controller'

function assetPreviewImage () {
  return {
    restrict: 'E',
    scope: {
      template: '=',
      location: '<',
      contextData: '<',
      previewFlags: '=',
      publicCampaign: '<',
      linkUuid: '<',
      allTemplates: '<'
    },
    templateUrl: '/core/directives/asset-preview-image/asset-preview-image.html?$$REVISION$$',
    controller: AssetPreviewImageController
  }
}
export { assetPreviewImage }
